module.exports = __webpack_public_path__ + "static/scale-model-of-george-bush-childhood-home-museum-in-midland-texas-e5afdc3d508f4f9cf2ca01194f2ed0fb.png";